<!--
 * @Author:
 * @Date: 2022-04-21 10:06:55
 * @LastEditTime: 2022-09-29 11:50:22
 * @LastEditors: shenlin
 * @Description:
-->
<template>
  <div class="list" @click="listTap(item.id)">
    <div class="list-title" v-html="item.title"></div>
    <div class="info-wrap">
      <div class="list-tab" v-if="item.reportType">{{ item.reportType }}</div>
      <div class="list-time">
        {{ leaveTime(item.time || item.publishDate) }}
      </div>
      <!-- <div class="list-type" v-if="item.type">{{item.type}}</div> -->
    </div>
  </div>
</template>
<script>
import { Toast } from 'vant'
import moment from 'moment'
import { getLocalStorage } from '@utils'
import { newSaveRecord, newSaveUVRecord } from '@api/lishui'
export default {
  props: ['item', 'type'],
  data() {
    return {
      userInfo: getLocalStorage('lishuiUserInfo')
        ? JSON.parse(getLocalStorage('lishuiUserInfo'))
        : {}
    }
  },
  methods: {
    // 过滤秒:格式化时间
    leaveTime(value) {
      if (value) {
        return moment(value).format('YYYY-MM-DD')
      } else {
        return ''
      }
    },
    // 埋点
    buriedPoint() {
      const params = {
        applyName: this.$route.meta.title,
        creditCode: this.userInfo.creditCode,
        entName: this.userInfo.entName,
        mobile: this.userInfo.mobile
      }
      JSSDK_QYM.sendData({
        pageUrl: this.$route.path,
        pageId: window.location,
        pageName: this.$route.meta.title,
        userAgent: ''
      })
      newSaveRecord(params).then(res => { })
      newSaveUVRecord(params).then(res => { })
    },
    listTap(id) {
      this.buriedPoint()
      this.$router.push({
        path: '/servicebus/details',
        query: {
          id: id,
          type: this.type
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.list {
  padding: 15px;
  border-bottom: 1px solid #eee;
  &-title {
    font-size: 15px;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .info-wrap {
    display: flex;
    align-items: center;
    margin-top: 10px;
    .list-time {
      font-size: 13px;
      color: #999;
    }
    .list-type {
      font-size: 12px;
      padding: 0px 6px;
      border: 1px solid #3366ff;
      background: #3366ff;
      color: #fff;
      margin-right: 0.24rem;
      border-radius: 2px;
      padding: 0.1rem;
    }
    .list-tab {
      font-size: 12px;
      background: #eff6ff;
      color: rgba(0, 112, 255, 100);
      margin-right: 0.24rem;
      border-radius: 2px;
      padding: 0.1rem 0.2rem;
    }
  }
}
</style>
